import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import "./index.css";
import FDCalculator from "./tools/fd-calculator";
import PPFCalculator from "./tools/ppf-calculator";
import GridFlexGeneratorReact from './tools/gridflex';

import SvgLogoGeneratorPro from './tools/svgLogoGeneratorPro';


//import SvgLogoGeneratorPro from "./tools/svgLogoGeneratorPro";

const PDFJS = window.pdfjsLib;

export default function App() {
  const [pdf, setPdf] = React.useState("");
  const [width, setWidth] = React.useState(0);
  const [images, setImages] = React.useState([]);
  const [height, setHeight] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(1);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pdfRendering, setPdfRendering] = React.useState("");
  const [pageRendering, setPageRendering] = React.useState("");

  async function showPdf(event) {
    try {
      setPdfRendering(true);
      const file = event.target.files[0];
      const uri = URL.createObjectURL(file);
      var _PDF_DOC = await PDFJS.getDocument({ url: uri });
      setPdf(_PDF_DOC);
      setPdfRendering(false);
      document.getElementById("file-to-upload").value = "";
    } catch (error) {
      alert(error.message);
    }
  }

  function changePage() {
    setCurrentPage();
  }

  async function renderPage() {
    setPageRendering(true);
    const imagesList = [];
    const canvas = document.createElement("canvas");
    canvas.setAttribute("className", "canv");
    let canv = document.querySelector(".canv");

    for (let i = 1; i <= pdf.numPages; i++) {
      var page = await pdf.getPage(i);
      var viewport = page.getViewport({ scale: 1 });
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      var render_context = {
        canvasContext: canvas.getContext("2d"),
        viewport: viewport
      };
      console.log("page lenght", pdf.numPages);
      setWidth(viewport.width);
      setHeight(viewport.height);
      await page.render(render_context).promise;
      let img = canvas.toDataURL("image/png");
      imagesList.push(img);
    }
    setImages(imagesList);
    setPageRendering(false);
  }

  useEffect(() => {
    pdf && renderPage();
    // eslint-disable-next-line
  }, [pdf, currentPage]);

  const styles = {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "5px"
    },
    imageWrapper: {
      // width: "300px",
      // height: "350px",
      border: "1px solid rgba(0,0,0,0.15)",
      borderRadius: "3px",
      boxShadow: "0 2px 5px 0 rgba(0,0,0,0.25)",
      padding: "0"
    }
  };

  return (
    <div className="App">

      <Router>
      <div className="min-h-screen bg-gray-50">
        {/* Navbar */}
        <nav className="bg-white shadow px-6 py-4 flex gap-4">
          <Link to="/" className="text-blue-600 hover:underline">Home</Link>
          <Link to="/gridflexgenerator" className="text-blue-600 hover:underline">GridFlexGeneratorReact Generator</Link>
          <Link to="/logo" className="text-blue-600 hover:underline">Logo Generator</Link>
          <Link to="/fdcalculator" className="text-blue-600 hover:underline">FD Calculator</Link>
          <Link to="/ppfcalculator" className="text-blue-600 hover:underline">PPF Calculator</Link>
        </nav>

        {/* Routes */}
        <div className="p-6">
          <Routes>
            {/* <Route path="/" element={<Home />} /> */}
                        
            <Route path="/gridflexgenerator" element={<GridFlexGeneratorReact />} />
            <Route path="/logo" element={<SvgLogoGeneratorPro />} />
            <Route path="/fdcalculator" element={<FDCalculator />} />
            <Route path="/ppfcalculator" element={<PPFCalculator />} />
          </Routes>
        </div>
      </div>
    </Router>



      

     
    </div>
  );
}
